import { getMessaging } from './firebase-messaging.js';

/**
 * Handle foreground messages
 */
export function handleForegroundMessages() {
	const messaging = getMessaging();
	if (!messaging) return;

	messaging.onMessage((payload) => {
		const notificationTitle = payload.notification?.title || 'New Notification';
		const notificationOptions = {
			body: payload.notification?.body || '',
			icon: payload.notification?.icon || '',
		};

		// Show notification
		if (Notification.permission === 'granted') {
			new Notification(notificationTitle, notificationOptions);
		}

		// Trigger custom event for UI updates
		const event = new CustomEvent('fcm_message_received', { detail: payload });
		window.dispatchEvent(event);
	});
}
